import { Collapse, Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";
import MainCard from "../../../../components/Maincard";
import CustomAutocompleteComp from "../../../newComponent/AutocompleteComp";
import { useState } from "react";
import CustomTextFieldComp from "../../../newComponent/customTextFieldComp";
import { useGetTokenOrLogout } from "../../../../utils/token";
import ApplyFilterButton from "../../../newComponent/NewButtonComp/ApplyFilterButton";
import ResetFilterButton from "../../../newComponent/NewButtonComp/ResetFilterButton";
import { useDateUtils } from "../../../../utils/formatTime";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function MiscellaneousPaymentFilter({
  open,
  setSearchData,
  setPayments,
  setOriginalData,
  showSnackbar,
  originalData,
  setIsLoading,
}) {
  const userId = localStorage.getItem("userId");
  const getTokenOrLogout = useGetTokenOrLogout();
  const { todaysDate, oneMonthAgoDate } = useDateUtils();
  const [testTypeList, setTestTypeList] = useState([]);
  const [testType, setTestType] = useState([]);
  const [pteId, setPteId] = useState(null);
  const [collectedByList, setCollectedByList] = useState([]);
  const [collectedBy, setCollectedBy] = useState([]);
  const [collectedFromdate, setCollectedFromDate] = useState(oneMonthAgoDate);
  const [collectedToDate, setCollectedToDate] = useState(todaysDate);
  const [statusList, setStatusList] = useState([
    { id: 1, name: "Pending", value: "pending" },
    { id: 2, name: "Approved", value: "approved" },
    { id: 3, name: "Cancelled", value: "cancelled" },
    { id: 4, name: "Denied", value: "denied" },
  ]);
  const [status, setStatus] = useState([]);
  const [approvealFromDate, setApprovalFromDate] = useState("");
  const [approvalToDate, setApprovalToDate] = useState("");
  const [branchList, setbranchList] = useState([]);
  const [branch, setBranch] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}route/getalltesttype`);
        if (response.ok) {
          const data = await response.json();
          setTestTypeList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}route/user-wise-emp/${userId}`);
        if (response.ok) {
          const data = await response.json();
          setCollectedByList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}route/fetchbranch/${userId}`);
        if (response.ok) {
          const data = await response.json();
          setbranchList(data);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allTestList = [{ name: "Select All" }, ...testTypeList];
  const handleTestchange = (event, value) => {
    if (value.some((option) => option.name === "Select All")) {
      setTestType(testTypeList);
    } else {
      setTestType(value);
    }
  };
  const allCollectedBy = [{ first_name: "Select All" }, ...collectedByList];
  const handleChangeCollectedBy = (event, value) => {
    if (value.some((option) => option.first_name === "Select All")) {
      setCollectedBy(collectedByList);
    } else {
      setCollectedBy(value);
    }
  };

  const allStausList = [{ name: "Select All" }, ...statusList];

  const handleChangeStatus = (event, value) => {
    if (value.some((option) => option.name === "Select All")) {
      setStatus(statusList);
    } else {
      setStatus(value);
    }
  };

  const allBranchList = [{ branch_name: "Select All" }, ...branchList];

  const handleChangeSBranch = (event, value) => {
    if (value.some((option) => option.branch_name === "Select All")) {
      setBranch(branchList);
    } else {
      setBranch(value);
    }
  };

  const handleApplyFilter = async (event) => {
    event.preventDefault();
    // Handle form submission logic here

    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    setIsLoading(true);
    const requestData = {
      user_id: parseInt(userId),
      test_type_id: testType.map((i) => i.id),
      pte_id: pteId,
      collected_by: collectedBy.map((i) => i.user_id),
      branch_collected_by: branch.map((i) => i.id),
      created_from_date: collectedFromdate || null,
      created_to_date: collectedToDate || null,
      approval_status: status.map((i) => i.value),
      approved_from_date:approvealFromDate || null,
      approved_to_date :approvalToDate || null 
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}miscellaneousfees/filtermiscellaneousfees`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        const result = await response.json();

        const sortedData = result.sort(
          (a, b) => new Date(b.payment_date) - new Date(a.payment_date)
        );

        setPayments(sortedData);
        setSearchData(sortedData);
        setIsLoading(false);
      } else if (response.status === 404) {
        showSnackbar("Could't find any data", "error");
        setPayments([]);
        setSearchData([]);
        setIsLoading(false);
      } else if (response.status === 500) {
        showSnackbar("Server Error", "error");
        setPayments([]);
        setSearchData([]);
        setIsLoading(false);
      } else {
        setPayments([]);
        setSearchData([]);
        setIsLoading(false);
        showSnackbar("Error Fetching Data", "error");
      }
    } catch (error) {
      setPayments([]);
      setSearchData([]);
      setIsLoading(false);
      showSnackbar("Error Fetching Data", "error");
    }
  };

  const handleResetFilter = () => {
    setTestType([]);
    setCollectedBy([]);
    setPteId("");
    setCollectedFromDate(oneMonthAgoDate);
    setCollectedToDate(todaysDate);
    setStatus([]);
    setApprovalFromDate("");
    setApprovalFromDate("");
    setPayments(originalData);
    setSearchData(originalData);
    setBranch([])
  };

  return (
    <Collapse in={open}>
      <MainCard>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Typography variant="h6">Test Type</Typography>
            <CustomAutocompleteComp
              fullWidth
              value={testType}
              multiple
              onChange={handleTestchange}
              options={allTestList}
              getOptionLabel={(option) => option.name}
              tooltipContent={(option) => option.name}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Typography variant="h6">PTE ID</Typography>
            <CustomTextFieldComp
              fullWidth
              size="normal"
              type="text"
              value={pteId}
              onChange={(e) => setPteId(e.target.value)}
              InputProps={{
                style: { borderRadius: "10px" },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Typography variant="h6">Collected By</Typography>
            <CustomAutocompleteComp
              fullWidth
              value={collectedBy}
              multiple
              onChange={handleChangeCollectedBy}
              options={allCollectedBy}
              getOptionLabel={(option) => `${option.first_name ? option.first_name : ""} ${
                option.last_name ? option.last_name : ""
              }`}
              tooltipContent={(option) => `${option.first_name ? option.first_name : ""} ${
                option.last_name ? option.last_name : ""
              }`}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Typography variant="h6">Branch Collected By</Typography>
            <CustomAutocompleteComp
              fullWidth
              value={branch}
              multiple
              onChange={handleChangeSBranch}
              options={allBranchList}
              getOptionLabel={(option) => option.branch_name}
              tooltipContent={(option) => option.branch_name}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Typography variant="h6">Collected From Date</Typography>
            <CustomTextFieldComp
              fullWidth
              size="normal"
              type="date"
              value={collectedFromdate}
              onChange={(e) => setCollectedFromDate(e.target.value)}
              InputProps={{
                style: { borderRadius: "10px" },
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Typography variant="h6">Collected To Date</Typography>
            <CustomTextFieldComp
              fullWidth
              size="normal"
              type="date"
              value={collectedToDate}
              onChange={(e) => setCollectedToDate(e.target.value)}
              InputProps={{
                style: { borderRadius: "10px" },
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Typography variant="h6">Approved From Date</Typography>
            <CustomTextFieldComp
              fullWidth
              size="normal"
              type="date"
              value={approvealFromDate}
              onChange={(e) => setApprovalFromDate(e.target.value)}
              InputProps={{
                style: { borderRadius: "10px" },
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Typography variant="h6">Approved To Date</Typography>
            <CustomTextFieldComp
              fullWidth
              size="normal"
              type="date"
              value={approvalToDate}
              onChange={(e) => setApprovalToDate(e.target.value)}
              InputProps={{
                style: { borderRadius: "10px" },
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <Typography variant="h6">Status</Typography>
            <CustomAutocompleteComp
              fullWidth
              value={status}
              multiple
              onChange={handleChangeStatus}
              options={allStausList}
              getOptionLabel={(option) => option.name}
              tooltipContent={(option) => option.name}
            />
          </Grid>

          <Grid item xs={12} container gap={1} justifyContent="end">
            <ApplyFilterButton onClick={handleApplyFilter} />
            <ResetFilterButton onClick={handleResetFilter} />
          </Grid>
        </Grid>
      </MainCard>
    </Collapse>
  );
}
